"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/inherits");

var _require = require("../../utils"),
    mixin = _require.mixin;

var SVGNumber = require("../generated/SVGNumber");

var SVGGraphicsElementImpl = require("./SVGGraphicsElement-impl").implementation;

var WindowEventHandlersImpl = require("./WindowEventHandlers-impl").implementation;

var _require2 = require("../helpers/internal-constants"),
    domSymbolTree = _require2.domSymbolTree;

var _require3 = require("../node-type"),
    ELEMENT_NODE = _require3.ELEMENT_NODE;

var SVGSVGElementImpl =
/*#__PURE__*/
function (_SVGGraphicsElementIm) {
  _inherits(SVGSVGElementImpl, _SVGGraphicsElementIm);

  function SVGSVGElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, SVGSVGElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SVGSVGElementImpl).call(this, args, privateData));

    _this._proxyWindowEventsToWindow();

    return _this;
  }

  _createClass(SVGSVGElementImpl, [{
    key: "createSVGNumber",
    value: function createSVGNumber() {
      return SVGNumber.createImpl([], {});
    }
  }, {
    key: "getElementById",
    value: function getElementById(elementId) {
      // TODO: optimize with _ids caching trick; see Document class.
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = domSymbolTree.treeIterator(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var node = _step.value;

          if (node.nodeType === ELEMENT_NODE && node.getAttribute("id") === elementId) {
            return node;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    }
  }, {
    key: "suspendRedraw",
    value: function suspendRedraw() {
      return 1;
    }
  }, {
    key: "unsuspendRedraw",
    value: function unsuspendRedraw() {}
  }, {
    key: "unsuspendRedrawAll",
    value: function unsuspendRedrawAll() {}
  }, {
    key: "forceRedraw",
    value: function forceRedraw() {}
  }]);

  return SVGSVGElementImpl;
}(SVGGraphicsElementImpl);

mixin(SVGSVGElementImpl.prototype, WindowEventHandlersImpl.prototype);
module.exports = {
  implementation: SVGSVGElementImpl
};